import { ONE_DAY_MS } from '~/shared/constants/time'

export function toAbs(time: number) {
  // less than a day (or negative) -> relative time)
  if (time < ONE_DAY_MS) return Date.now() + time
  return time
}

/* Checks if value inside [storageDuration---now] window */
export const validateStorageDuration = (
  storageDurationSec: number,
  value: number
): number => {
  // value may be relative or absolute
  const valueAbs = toAbs(value)
  const storageDurationMs = storageDurationSec * 1000

  if (Date.now() - storageDurationMs < valueAbs) return value // value inside storageDuration window

  return -storageDurationMs
}
